// Copyright (C) 2022 Intel Corporation
//
// SPDX-License-Identifier: MIT
import { SampleActions, SampleActionTypes } from './sample-actions';

const defaultState = {
    data: {},
};

export default function (
    state = defaultState,
    action: SampleActions,
): any {
    switch (action.type) {
        case SampleActionTypes.GET_SAMPLE: {
            return {
                ...state,
            };
        }
        case SampleActionTypes.GET_SAMPLE_SUCCESS:
            return {
                ...state,
                data: action.payload.sample,
            };
        case SampleActionTypes.GET_SAMPLE_FAILED:
            return {
                ...state,
            };
        default:
            return state;
    }
}
